
import { computed, defineComponent, ref, onBeforeUnmount } from "vue";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"
import useAlert from "@/composables/Alert";
import axios from "axios";

export default defineComponent({
  name: "ModalEditarFiltro",
  components: {
    Button
  },
  props: {
    fechaModal: Function,
    marcas: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
    tiposDeFiltro: { type: Array as () => Array<{ id_tipo_produto: string, nome: string; descricao: string | number }>, default: () => [] }
  },
  setup(props) {
    const { showTimeAlert } = useAlert();
    const emitter = useEmitter();
    const loadSalvar = ref(false);
    const spanWarning = ref(false);
    const marcasDeFiltros = computed(() => props.marcas);
    const imagem = ref<HTMLInputElement>();
    const filtroUnico: any = ref({
        id: "",
        marca: "",
        id_marca: "", //passa
        filtro: "",//passa
        tipo: "",
        id_tipo: "",//passa
        descricao: "",//passa
        ean: "",//passa
        status: "",//passa
        imagem: ""//passa
    });
    const statusOptions = ['Disponível', 'Obsoleto'];   

    const validateOnlyNumbers = (val: string, field: string) => {
      filtroUnico.value[field] = val.replace(/\D/g, '');
    };

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = filtroUnico.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        filtroUnico.value.imagem = file;
        filtroUnico.value.imagemPreview = buildImagePreview(file);
      }
    }

    // abre o modal preenchendo dados quando receber o evento
    const openHandler = (payload: any) => {
      if (!payload?.filtro) return;
      filtroUnico.value = { ...payload.filtro };
      filtroUnico.value.imagemPreview = buildImagePreview(filtroUnico.value.imagem);
    };

    const startHandler = () => {
      loadSalvar.value = true;
    };
    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      if (payload?.success) {
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("openEditFiltro", openHandler);
      emitter.on("editFiltro:start", startHandler);
      emitter.on("editFiltro:finish", finishHandler);
    }

    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("openEditFiltro", openHandler);
        emitter.off("editFiltro:start", startHandler);
        emitter.off("editFiltro:finish", finishHandler);
      }
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = null;
      }
    });

    // marcasDeFiltros is derived from props.marcas (provided by parent)

    async function getToken() {
      return localStorage.getItem("token_usuario");
    }

    // quando clicar salvar, realiza o update aqui e emite eventos de start/finish
    async function onSave() {
      if (!filtroUnico.value.id_tipo || !filtroUnico.value.id_marca || !filtroUnico.value.filtro || !filtroUnico.value.ean || !filtroUnico.value.status) {
        spanWarning.value = true;
        return;
      }
      spanWarning.value = false;
      if (emitter && emitter.emit) emitter.emit("editFiltro:start");

      try {
        let body: any = { ...filtroUnico.value };
        const headers: any = { Authorization: `Bearer ${await getToken()}` };

        if (filtroUnico.value.imagem instanceof File) {
          const formData = new FormData();
          Object.entries(filtroUnico.value).forEach(([key, val]) => {
            if (key === "imagem") return;
            if (val === undefined || val === null) formData.append(key, "");
            else if (typeof val === "object") formData.append(key, JSON.stringify(val));
            else formData.append(key, String(val));
          });
          formData.append("imagem", filtroUnico.value.imagem);
          body = formData;
        }

        await axios.post("editaFiltro", body, { headers });
        if (emitter && emitter.emit) emitter.emit("editFiltro:finish", { success: true });
      } catch (err: any) {
        console.error(err);
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel editar o produto.", "error");
        }
        if (emitter && emitter.emit) emitter.emit("editFiltro:finish", { success: false });
      }
    }

    function openFileDialog() {
      imagem.value?.click();
    }

    return {
      filtroUnico,
      handleImgFileChange,
      onSave,
      loadSalvar,
      spanWarning,
      marcasDeFiltros,
      fileName,
      statusOptions,
      openFileDialog,
      imagem,
      validateOnlyNumbers
    };
  }
});
